import React from "react";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMRoadblockTableList } from "../../components/CRMRoadblock/CRMRoadblockTableList/CRMRoadblockTableList";
import { CRMRoadblockViewChecklist } from "../../components/CRMRoadblock/CRMRoadblockViewChecklist/CRMRoadblockViewChecklist";
import { roadblockDetailViewFromListingForm } from "../../models/RoadblockDetailView";
import { roadblockListViewFromListingItem } from "../../models/RoadblockListView";

export const CRMListingRoadblocksContainer = (props: TContainerStateProps): JSX.Element => {
    const listingId = props.state.forms.listing_page.data.output.form.edited.id;
    const roadblocksForm = props.state.forms.listing_page.roadblocks;
    const openRoadblock = props.state.forms.listing_page.open_roadblock;
    const isOpen = openRoadblock.edited.id !== "";
    const hasRoadblocks = roadblocksForm.children.roadblocks.length > 0;

    React.useEffect(
        () => {
            if (listingId) {
                props.dispatch({
                    type: "LISTING_PAGE_GET_ROADBLOCKS",
                    payload: listingId,
                });
            }
        },
        [listingId]
    );

    return (
        <>
            {/* TABLE LIST — plain conditional render rather than the conveyancing block's
                scroll views. Those wrap their children in `.crm-block-view`, a nested scroll
                container sized to a fixed-height block column. This sidebar is page-scrolled,
                so the nested scroller detached from the page: scrolling Progression left a
                ~440px blank hole where the panel had been, and the popouts were then sized
                against that box rather than the viewport. Without the wrapper the popout's
                own measurement falls back to the viewport, which is what it wants here. */}
            {hasRoadblocks && ! isOpen &&
                <CRMRoadblockTableList
                    roadblocks={roadblocksForm.children.roadblocks.map(roadblockListViewFromListingItem)}
                    assignableUsers={roadblocksForm.children.assignable_users}
                    awaitableEntities={roadblocksForm.children.awaitable_entities}
                    onClick={(roadblockId) => props.dispatch({
                        type: "LISTING_PAGE_OPEN_ROADBLOCK",
                        payload: roadblockId,
                    })}
                    onAssign={(payload) => props.dispatch({
                        type: "LISTING_PAGE_ROADBLOCK_ASSIGN",
                        payload,
                    })}
                    onAwait={(payload) => props.dispatch({
                        type: "LISTING_PAGE_ROADBLOCK_AWAIT",
                        payload,
                    })}
                    onCancelAwait={(payload) => props.dispatch({
                        type: "LISTING_PAGE_ROADBLOCK_CANCEL_AWAIT",
                        payload,
                    })}
                />
            }

            {/* SINGLE VIEW — CHECKLIST */}
            {isOpen &&
                <CRMRoadblockViewChecklist
                    sessionUser={props.state.global.user}
                    view={roadblockDetailViewFromListingForm(openRoadblock)}
                    onClose={() => props.dispatch({type: "LISTING_PAGE_CLOSE_ROADBLOCK", payload: undefined})}
                    onOpenChat={() => undefined}
                    onOpenForm={() => undefined}
                    onOpenEvidenceLink={() => undefined}
                    onRefresh={() => props.dispatch({
                        type: "LISTING_PAGE_OPEN_ROADBLOCK",
                        payload: openRoadblock.edited.id,
                    })}
                    onToggleManualItem={(change) => props.dispatch({
                        type: "LISTING_PAGE_TOGGLE_ROADBLOCK_MANUAL_ITEM",
                        payload: {...change, roadblock_id: openRoadblock.edited.id},
                    })}
                    onSignOff={() => undefined}
                />
            }
        </>
    );
};
